import React from 'react';
import Header from '../header';
import Footer from '../footer';
import UnderConstruction from '../underConstruction';

const TeamPage = () => {
    return (
        <div>
            <Header />
            <UnderConstruction />
            <Footer />
        </div>
    )
}

export default TeamPage;